import React from 'react';

import StandardBet from "../../StandardBet";

import "./index.scss";
import { IGameTableType } from "@/types/GlobalTypes";

//SamGong
export default class M32 extends React.Component<IGameTableType> {
	render() {
		const { langdata } = this.props;

		//Desktop & Landscape
		const _bets = ["odd", "even", "big", "small", "three-pictures", "anypicture"];
		
		const either3Bet = "three-pictures";
		const either3Group = "either_3picts";

		const anyPicBet = "anypicture";
		const anyPicGroup = "either_anypict";

		const playerBets = _bets.map((item, idx) =>
			idx < 4 ? "player-" + item :
			item + "-player"
		); //50-50

		const playerGroups = ["n50", "n50", "n50", "n50", "player_3picts", "player_anypict"];

		const bankerBets = _bets.map((item, idx) =>
			idx < 4 ? "banker-" + item :
			item + "-banker"
		);
		const bankerGroups = playerGroups.map(item => item.replace("player", "banker"));

		// const leftRightLabels = ["Odd", "Even", "Big", "Small", "3 Picture", "Any Picture"];
		const leftRightLabels = [
			langdata["txt_odd"],
			langdata["txt_even"],
			langdata["txt_big"],
			langdata["txt_small"],
			langdata["txt_3_pictures"],
			langdata["txt_any_pictures"],
		];
		const leftRightBetTypes = ["1:0.95", "1:0.95", "1:0.95", "1:0.95", "1:1499", "1:89"];

		//Portrait
		const portraitBets = [
			[
				[playerBets[0], playerBets[1]],
				[playerBets[2], playerBets[3]],
				[playerBets[4], playerBets[5]]
			],
			[
				[bankerBets[0], bankerBets[1]],
				[bankerBets[2], bankerBets[3]],
				[bankerBets[4], bankerBets[5]]
			]
		];

		const portraitGroups = [
			[
				[playerGroups[0], playerGroups[1]],
				[playerGroups[2], playerGroups[3]],
				[playerGroups[4], playerGroups[5]]
			],
			[
				[bankerGroups[0], bankerGroups[1]],
				[bankerGroups[2], bankerGroups[3]],
				[bankerGroups[4], bankerGroups[5]]
			]
		];

		// const portraitLabels = [["Odd", "Even"], ["Big", "Small"], ["3 Picture", "Any Picture"]];
		const portraitLabels = [
			[langdata["txt_odd"],
			langdata["txt_even"]],
			[langdata["txt_big"],
			langdata["txt_small"]],
			[langdata["txt_3_pictures"],
			langdata["txt_any_pictures"]]
		];
		const portraitBetType = [["1:0.95", "1:0.95"], ["1:0.95", "1:0.95"], ["1:1499", "1:89"]];

		return (
			//Mobile Portrait
			this.props.portrait ? (
				<div className="sl-table m32">
					<div className="row">
						<StandardBet
							classes="col-xs-6 blue"

							betLabel={langdata["txt_player"]}

							betType="1:0.97"
							betNum="player"
							betGroup="player"

							commonProps={this.props}
						/>

						<StandardBet
							classes="col-xs-6 red"

							betLabel={langdata["txt_banker"]}

							betType="1:0.97"
							betNum="banker"
							betGroup="banker"

							commonProps={this.props}
						/>
					</div>

					<div className="row">
						<StandardBet
							classes="col-xs-12 sl-green-old"

							betLabel={langdata["txt_tie"]}

							betType="1:0.95"
							betNum="tie"
							betGroup="tie"

							commonProps={this.props}
						/>
					</div>

					{
						portraitLabels.map((item, idx) => (
							<div key={"m32_portrait_" + idx} className="row">
								{
									item.map((subItem, subIdx) => (
										<StandardBet
											key={"m32_left_" + subItem + "_n50"}
											classes="col-xs-3 sl-green-old blue-text"

											betLabel={subItem}

											betType={portraitBetType[idx][subIdx]}
											betNum={portraitBets[0][idx][subIdx]}
											betGroup={portraitGroups[0][idx][subIdx]}

											commonProps={this.props}
										/>
									))
								}

								{
									item.map((subItem, subIdx) => (
										<StandardBet
											key={"m32_right_" + subItem + "_n50"}
											classes="col-xs-3 sl-green-old red-text"

											betLabel={subItem}

											betType={portraitBetType[idx][subIdx]}
											betNum={portraitBets[1][idx][subIdx]}
											betGroup={portraitGroups[1][idx][subIdx]}

											commonProps={this.props}
										/>
									))
								}
							</div>
						))
					}

					<div className="row">
						<StandardBet
							classes="col-xs-6 sl-green-old"

							betLabel={langdata["txt_either_3_picture"]} // "Either 3 Picture"

							betType="1:776"
							betNum={either3Bet}
							betGroup={either3Group}

							commonProps={this.props}
						/>

						<StandardBet
							classes="col-xs-6 sl-green-old"

							betLabel={langdata["txt_either_any_picture"]} // "Either Any Picture"

							betType="1:44"
							betNum={anyPicBet}
							betGroup={anyPicGroup}

							commonProps={this.props}
						/>
					</div>
				</div>
			) : (
					<div className="sl-table m32">
						<div className="left-group">
							{
								leftRightLabels.map((item, idx) => (
									<StandardBet
										key={"m32_left_" + item + "_n50"}
										classes="sl-green-old blue-text"

										betLabel={item}

										betType={leftRightBetTypes[idx]}
										betNum={playerBets[idx]}
										betGroup={playerGroups[idx]}

										commonProps={this.props}
									/>
								))
							}
						</div>

						<div className="middle-group">
							<div className="top-row">
								<StandardBet
									classes="blue"

									betLabel={langdata["txt_player"]}

									betType="1:0.97"
									betNum="player"
									betGroup="player"

									commonProps={this.props}
								/>

								<StandardBet
									classes="sl-green-old"

									betLabel={langdata["txt_tie"]}

									betType="1:21"
									betNum="tie"
									betGroup="tie"

									commonProps={this.props}
								/>

								<StandardBet
									classes="red"

									betLabel={langdata["txt_banker"]}

									betType="1:0.97"
									betNum="banker"
									betGroup="banker"

									commonProps={this.props}
								/>
							</div>

							<div className="bottom-row">
								<StandardBet
									classes="sl-green-old"

									betLabel={langdata["txt_either_3_picture"]}

									betType="1:776"
									betNum={either3Bet}
									betGroup={either3Group}

									commonProps={this.props}
								/>

								<StandardBet
									classes="sl-green-old"

									betLabel={langdata["txt_either_any_picture"]}

									betType="1:44"
									betNum={anyPicBet}
									betGroup={anyPicGroup}

									commonProps={this.props}
								/>
							</div>
						</div>

						<div className="right-group">
							{
								leftRightLabels.map((item, idx) => (
									<StandardBet
										key={"m32_right_" + item + "_n50"}
										classes="sl-green-old red-text"

										betLabel={item}

										betType={leftRightBetTypes[idx]}
										betNum={bankerBets[idx]}
										betGroup={bankerGroups[idx]}

										commonProps={this.props}
									/>
								))
							}
						</div>
					</div>
				)
		);
	}
}